import Utils from "./utils"

const utilsHelper = new Utils()
export default class LogHelper {
    constructor(log_level,end_point, is_debug, container_id){
        this.log_level = log_level
        this.end_point = end_point
        this.user_agent = navigator.userAgent
        this.url = decodeURIComponent(window.location.href)
        this.is_debug = is_debug 
        this.container_id = container_id
    }

    send(data) {
        
        if (this.is_debug !== true) {
            return
        }
        console.error('send',data)

        let exepected_fields = [
            "stage",
            "request_payload",
            "response_payload",
            "error_trace",
            "api_url",
            "clid",
            "view"
        ]   

        let result = {}
        exepected_fields.forEach(function(field){
            if (data[field]) {
                result[field] = data[field]
            }
            else {
                result[field] = ''
            }
            
        })
        result['level'] = this.log_level[data['level']]
        result['container_id'] = this.container_id
        result['url'] = this.url
        result['user_agent'] = this.user_agent
        // result['timestamp'] = new Date().toISOString()
        // result['datetime'] = this.getYYYYMMDDHHMMSS(timestamp, '-')
        // result['new_timestamp'] = timestamp
        /*
        utilsHelper.callAPI(
            '',
            'POST',
            this.end_point,
            result
        )
        */
    }
}